import { BordOneToneIcon } from 'components/NudosComponents';
import EditableOrderRow from '../EditableOrderRow/EditableOrderRow';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { IOrderPriceEditionForm } from '../../OrderPriceEdition.types';
import './ToolOrderEdition.scss';

interface IToolOrderEditionProps {
  serial?: string;
  saleIndex: number;
}

const ToolOrderEdition = ({ serial, saleIndex }: IToolOrderEditionProps) => {
  const { control } = useFormContext<IOrderPriceEditionForm>();
  const { fields: sales } = useFieldArray({
    control,
    name: `sales`
  });

  return (
    <section className="toolOrderEdition">
      <div className="toolSerial">
        <BordOneToneIcon variant="barCode2" customWidth="16px" stroke="black" standardSize={32} />
        <span>Serial:</span>
        <span>{serial}</span>
      </div>
      <EditableOrderRow key={sales?.[saleIndex]?.id || `sale-${saleIndex}`} registerReference={`sales.${saleIndex}`} />
    </section>
  );
};

export default ToolOrderEdition;
